/**
 * Drops the service worker and every Cache Storage entry, then reloads so the
 * browser fetches the latest build from the network.
 */
export async function forceRefreshApp() {
    try {
        if ('serviceWorker' in navigator) {
            const registrations =
                await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((r) => r.unregister()));
        }
        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
        }
    } catch (error) {
        console.warn('Failed to clear caches before refresh', error);
    }
    window.location.reload();
}
